import React, { FC } from 'react';
import classNames from 'classnames';
import { Rpt, Stmt } from '@shared/api';
import { acceptUTC } from '../../lib';
import { formats } from '@shared/utils';
import './General.scss';

interface IISOReportInfoProps {
    fieldName: string;
    value: string | number | boolean;
    Icon?: React.FC;
    className?: string;
}

const ISOReportInfo: FC<IISOReportInfoProps> = (props) => {
    const { fieldName, value, Icon, className } = props;

    return (
        <div className={classNames('iso-report-general-info__info-item', className)}>
            <span className='iso-report-general-info__info-header'>{fieldName}:</span>
            <span className={classNames('iso-report-general-info__info-content', value, { nullable: !value })}>
                {Icon && <Icon />} {value}
            </span>
        </div>
    );
};

interface IGeneralProps {
    data: Rpt | Stmt;
}

export const General: React.FC<IGeneralProps> = ({ data }) => {
    if (!data) {
        return null;
    }

    return (
        <div className='iso-report-general-info'>
            <ISOReportInfo
                fieldName={'ID'}
                value={data.id}
            />
            <ISOReportInfo
                fieldName={'Creation date'}
                value={acceptUTC(data.creDtTm, formats.fullTime)}
            />
            <ISOReportInfo
                fieldName={'From date'}
                value={acceptUTC(data.frToDt.frDtTm, formats.fullTime)}
            />
            <ISOReportInfo
                fieldName={'To date'}
                value={acceptUTC(data.frToDt.toDtTm, formats.fullTime)}
            />
        </div>
    );
};
